module.exports = __webpack_public_path__ + "static/media/pages_back.729e3f8c.jpg";